import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { browserHistory, Router } from 'react-router'

/** intl **/
import { addLocaleData, IntlProvider } from 'react-intl'
import fr from 'react-intl/locale-data/fr'
import en from 'react-intl/locale-data/en'
import de from 'react-intl/locale-data/de'
import es from 'react-intl/locale-data/es'
import it from 'react-intl/locale-data/it'
import ja from 'react-intl/locale-data/ja'
import pt from 'react-intl/locale-data/pt'
import * as QbMessages from './messages'

/** React routes et store **/
import { syncHistoryWithStore } from 'react-router-redux'
import configureStore from './store/configureStore'
import routesFactory from './routes'

/** utils **/
import injectTapEventPlugin from 'react-tap-event-plugin'

/** CSS **/
import './resources/css/style.css'

import { registerAudioPlayerStore } from './components/miniPlayer/AudioPlayer/playerActions'
import { QbBusiness } from './utils/business/qbbusiness'
import areIntlLocalesSupported from 'intl-locales-supported'

injectTapEventPlugin()

import GTMController from "./utils/kpi/GTMController"

if (window.__ENVIRONMENT__ === 'production') console.log = () => {
}

const localesMyAppSupports = ['en', 'de', 'fr', 'es', 'it', 'ja', 'pt']

function main() {
	if (global.Intl) {
		// Determine if the built-in `Intl` has the locale data we need.
		if (!areIntlLocalesSupported(localesMyAppSupports)) {
			// `Intl` exists, but it doesn't have the data we need, so load the
			// polyfill and patch the constructors we need with the polyfill's.
			const IntlPolyfill = require('intl')
			Intl.NumberFormat = IntlPolyfill.NumberFormat
			Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat
		}
	} else {
		// No `Intl`, so use and load the polyfill.
		global.Intl = require('intl')
		require('intl/locale-data/jsonp/en.js')
		require('intl/locale-data/jsonp/de.js')
		require('intl/locale-data/jsonp/fr.js')
		require('intl/locale-data/jsonp/es.js')
		require('intl/locale-data/jsonp/it.js')
		require('intl/locale-data/jsonp/ja.js')
		require('intl/locale-data/jsonp/pt.js')
	}

	addLocaleData([...fr, ...en, ...de, ...es, ...it, ...ja, ...pt])
	const formats = {
		date: {
			datetime: {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric'
			}
		}
	}
	let locale
	let messages
	const language = navigator.language.split('-')[0]
	const country = navigator.language.split('-')[1]
	switch (language) {
		case 'fr':
			locale = 'fr'
			messages = QbMessages.fr
			break
		case 'de':
			locale = 'de'
			messages = QbMessages.de
			break
		case 'es':
			locale = 'es'
			messages = QbMessages.es
			break
		case 'it':
			locale = 'it'
			messages = QbMessages.it
			break
		case 'ja':
			locale = 'ja'
			messages = QbMessages.ja
			break
		case 'pt':
			locale = 'pt'
			messages = QbMessages.pt
			break
		case 'en':
		default:
			locale = 'en'
			messages = QbMessages.en
	}
	const intlConfig = {
		locale,
		formats: {
			...formats,
		},
		defaultLocale: 'en',
		defaultFormats: {
			...formats
		},
		messages
	}

	const store = configureStore({})
	QbBusiness.setReduxDispatcher(store.dispatch)
	registerAudioPlayerStore(store)
	const history = syncHistoryWithStore(browserHistory, store)
	const routes = routesFactory()
	GTMController.init(country, language)
	ReactDOM.render(
		<Provider store={store}>
			<IntlProvider {...intlConfig}>
				<Router history={history} routes={routes} onUpdate={() => GTMController.onLocationChanged()}/>
			</IntlProvider>
		</Provider>,
		document.getElementById('root')
	)
}

main()



// WEBPACK FOOTER //
// ./src/index.js